export const schema = {
  code: ''
}
